module.exports = __webpack_public_path__ + "static/media/02_Ministeredesaffairesetrangeres.de7dd3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_affaires-etrangeres/02_Ministeredesaffairesetrangeres.jpg
// module id = 1175
// module chunks = 37